module.exports = __webpack_public_path__ + "img/dy_p4_img_4.70161f36.png";